<app-header></app-header>
<app-right-side></app-right-side>
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="assets/img/loader.webp">
</div>
<div *ngIf="currentUser.success.user.user_type_id == '12' || currentUser.success.user.user_type_id == '13' || currentUser.success.user.user_type_id == '11'" >
    <div class="container" >
        <div class="row">
            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="ui-block2 responsive-flex" style="background-color: var(--background-color); color: var(--text-color);">
                    <div class="ui-block-title" >
                        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 h2"><i class="fad fa-tools"></i>&nbsp;Admin Control<hr><br></div>
                    </div>
                </div>
                <br>
                <div class="h1" style="text-align: center; color: #9e2626; font-weight: 500;"><i class="fad fa-exclamation-triangle"></i>&nbsp;You do not have permission to access this page.</div>
                <br>
                <a routerLink="/home" style="text-align: center;">
                    <div style="font-size: 17px; border: 3px solid #d8d8d8; background-color: #252525; color: white; border-radius: 10px; padding: 10px; width: 150px; margin: 0px auto;">
                        <i class="fad fa-home"></i>&nbsp;Back Home
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<div *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'"  class="container">
    <div class="row">
        <h2 class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style="background-color: var(--background-color); color: var(--text-color);"><i class="fad fa-tools"></i>&nbsp;Admin Control<hr></h2>
        
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h3 style="color: rgb(47, 190, 226);">Users ( <i class="fad fa-users"></i>&nbsp;{{users.length}} )</h3>
            <br>
            <form [formGroup]="searchForm" (ngSubmit)="search()">
                <div class="row" style="position: relative; left: 73.5%;">
                    <input type="text" class="form-control" name="email" placeholder="Type email to search..." formControlName="email" value="" style="height: 33px; width: 300px; font-size: 14px;" />
                    <button type="submit" class="btn" style="background-color: var(--background-color); color: var(--text-color);"><i class="fad fa-search"></i></button>
                </div>
            </form>
            <span style="font-size: 18px; position: relative; top:-40px; background-color: var(--background-color); color: var(--text-color);">Users Status:&nbsp;<i class="fad fa-check-circle" style="color: rgb(17, 202, 64);"></i>&nbsp;{{statususer1.user.length}}
            &nbsp;|&nbsp;
            <i class="fad fa-times-circle" style="color: #d61c1c;"></i>&nbsp;{{statususer2.user.length}}</span>
            <div style="font-size: 10px; background-color: var(--background-color); color: var(--text-color); position: relative; left: 15px; top:-20px" class="row">Users Rols :
            <div class="col-lg-12 col-12">&nbsp;</div>
            <div *ngFor="let rols of userrols" class="col-lg-2 col-2 row" style="width: 200px;">
                <div class="col-lg-12 col-12">
                    <span style="background-color: var(--background-color); color: var(--text-color);"><i class="fad fa-user-tag" style="background-color: var(--background-color); color: var(--text-color);"></i>&nbsp;{{rols.role}}</span>&nbsp;
                    <span style="color: chocolate; font-weight: 600;">({{rols.rolscount}})</span>
                </div>
            </div></div>
            <table class="table table-bordere1d" style="border-color: slategrey;">
                <thead>
                    <tr style="font-size: 14px; background-color: rgb(35, 105, 122); color: white; border-color:slategrey ;">
                        <td>ID</td>
                        <td>First Name</td>
                        <td>Last Name</td>
                        <td>User Name</td>
                        <td>Email</td>
                        <td style="text-align: center;">Active</td>
                        <td>User Role</td>
                        <td>Create Date</td>
                        <td style="text-align: center;">Action</td>
                    </tr>
                </thead>
                <tbody *ngIf="data.user.length == 0 ">
                    <tr *ngFor="let item of users | slice: (curPage * pageSize) - pageSize :curPage * pageSize | filter : queryString; let i = index"  style="font-size: 14px; background-color: var(--background-color); color: var(--text-color);">
                        <td>{{item.id}}</td>
                        <td>{{item.fullName}}</td>
                        <td>{{item.lastName}}</td>
                        <td>{{item.username}}</td>
                        <td>{{item.email}}</td>
                        <td><div *ngIf="item.status == 1" style="text-align: center; font-size: 18px;"><i class="fad fa-check-circle" style="color: rgb(17, 202, 64);"></i></div><div *ngIf="item.status == 0" style="text-align: center; font-size: 18px;"><i class="fad fa-times-circle" style="color: #d61c1c;"></i></div></td>
                        <td>{{item.role}}</td>
                        <td>{{item.created_at | date}}</td>
                        <td style="width: 130px;">
                            <div  style="text-align: center;">
                                <div style="text-align: center; text-align: center;">
                                    <button style="background-color: var(--background-color); border: 0px solid white;" (click)="deleteuser(item.id)"><i class="fad fa-trash" style="color: #9e2626; font-size: 20px;"></i></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="data.user.length >= 1">
                    <tr *ngFor="let item of data.user | slice: (curPage * pageSize) - pageSize :curPage * pageSize | filter : queryString; let i = index"  style="font-size: 14px; background-color: var(--background-color); color: var(--text-color);">
                        <td>{{item.id}}</td>
                        <td data-title="'Employee Id'" sortable="'item.lastName'">{{item.fullName}}</td>
                        <td>{{item.lastName}}</td>
                        <td>{{item.username}}</td>
                        <td>{{item.email}}</td>
                        <td><div *ngIf="item.status == 1" style="text-align: center; font-size: 18px;"><i class="fad fa-check-circle" style="color: rgb(17, 202, 64);"></i></div><div *ngIf="item.status == 0" style="text-align: center; font-size: 18px;"><i class="fad fa-times-circle" style="color: #d61c1c;"></i></div></td>
                        <td>{{item.role}}</td>
                        <td>{{item.created_at | date}}</td>
                        <td style="width: 130px;">
                            <div  style="text-align: center;">
                                <div style="text-align: center; text-align: center;">
                                    <button style="background-color: var(--background-color); border: 0px solid white;" (click)="deleteuser(item.id)"><i class="fad fa-trash" style="color: #d61c1c; font-size: 20px;"></i></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="pagination">
            <button [disabled] ="curPage == 1" (click)="curPage = curPage - 1" class="btn btn-dark" style="background-color: #d61c1c;">PREV</button>
            &nbsp;
                <span style="font-size: 14px; position: relative; top:8px;"> Page : <span style="color:var(--text-color)">{{curPage}}</span> of {{ numberOfPages() }} </span>
            &nbsp;
            <button [disabled] = "curPage >= users.length/pageSize" 
                (click) ="curPage = curPage + 1" class="btn btn-dark" style="background-color: rgb(35, 105, 122);">NEXT</button>
            </p>
        </div>
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h3 style="color: rgb(28, 204, 86);">Posts ( <i class="fad fa-newspaper"></i>&nbsp;{{feednews.length}} )</h3>
            <br>
            <form [formGroup]="searchForm2" (ngSubmit)="search2()">
                <div class="row" style="position: relative; left: 73.5%;">
                    <input type="text" class="form-control" name="fullName" placeholder="Type UserName to search..." formControlName="fullName" value="" style="height: 33px; width: 300px; font-size: 14px;" />
                    <button type="submit" class="btn" style="background-color: black; color: white;"><i class="fad fa-search"></i></button>
                </div>
            </form>
            <table class="table table-bordere1d" style="border-color: slategrey;">
                <thead>
                    <tr style="font-size: 14px; background-color: rgb(40, 100, 77); color: white; border-color:slategrey ;">
                        <td>Content</td>
                        <td>User Name</td>
                        <td>Post Date</td>
                        <td>Likes</td>
                        <td>Comments</td>
                        <td style="text-align: center;">Action</td>
                    </tr>
                </thead>
                <tbody *ngIf="data22.length == 0">
                    <tr *ngFor="let item2 of feednews | slice: (curPage * pageSize2) - pageSize2 :curPage * pageSize2| filter : queryString2; let i = index"  style="font-size: 14px; background-color: var(--background-color); color: var(--text-color);">
                        <td>{{item2.content}}</td>
                        <td>{{item2.user.fullName}}</td>
                        <td style="text-align: center;">{{item2.created_at | date}}</td>
                        <td style="text-align: center;"><i class="fad fa-thumbs-up" style="color:dodgerblue;"></i>&nbsp;{{item2.likesCounter}}</td>
                        <td style="text-align: center;"><i class="fad fa-comments"></i>&nbsp;{{item2.commentsCounter}}</td>
                        <td style="width: 130px;">
                            <div  style="text-align: center;">
                                <div style="text-align: center; text-align: center;">
                                    <button style="background-color: var(--background-color); border: 0px solid white;" (click)="deletepost(item2.id)"><i class="fad fa-trash" style="color: #9e2626; font-size: 20px;"></i></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="data22.length >= 1">
                    <tr *ngFor="let item21 of data22 | slice: (curPage * pageSize2) - pageSize2 :curPage * pageSize2| filter : queryString2; let i = index"  style="font-size: 14px; background-color: var(--background-color); color: var(--text-color);">
                        <td>{{item21.content}}</td>
                        <td>{{item21.fullName}}</td>
                        <td style="text-align: center;">{{item21.created_at | date}}</td>
                        <td style="text-align: center;"><i class="fad fa-thumbs-up" style="color:dodgerblue;"></i>&nbsp;{{item21.likesCounter}}</td>
                        <td style="text-align: center;"><i class="fad fa-comments"></i>&nbsp;{{item21.commentsCounter}}</td>
                        <td style="width: 130px;">
                            <div  style="text-align: center;">
                                <div style="text-align: center; text-align: center;">
                                    <button style="background-color: var(--background-color); border: 0px solid white;" (click)="deletepost(item21.postid)"><i class="fad fa-trash" style="color: #d61c1c; font-size: 20px;"></i></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="pagination">
            <button [disabled] ="curPage == 1" (click)="curPage = curPage - 1" class="btn btn-dark" style="background-color: #d61c1c;">PREV</button>
            &nbsp;
                <span style="font-size: 14px; position: relative; top:8px;"> Page : <span style="color:var(--text-color)">{{curPage}}</span> of {{ numberOfPages2() }} </span>
            &nbsp;
            <button [disabled] = "curPage >= feednews.length/pageSize2" 
                (click) ="curPage = curPage + 1" class="btn btn-dark" style="background-color: rgb(40, 100, 77);">NEXT</button>
            </p>
        </div>
    </div>
</div>
<div style="padding: 15px;"><hr class="hr-text gradient"  data-content="©2025 Copyright Football-Family.com"></div>
